import {Component,Input} from '@angular/core';
import {ListViewItem} from "../../../../domain/common/list-view/list-view-item";
import {MobileDevice} from "../../../../domain/profil/mobileDevice";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {Result,TypeCodeErreur} from "@domain/common/http/result";
import {filter,first} from "rxjs/operators";
import {ProfilService} from "@components/profil/profil.service";

/**
 * Composant d'affichage en liste des périphériques mobiles
 */
@Component({
  selector: 'profil-app-mobile-list-item',
  templateUrl: './profil-app-mobile-list-item.component.html'
})
export class ProfilAppMobileListItemComponent extends ListViewItem<MobileDevice> {
  /** Elément courant */
  @Input() data: MobileDevice;

    /**
     * Constructeur
     */
  constructor(
      private profilService: ProfilService,
      private translateService: TranslateService,
      private toastrService: ToastrService,
      private confirmService: ConfirmService
  ) {
    super();
  }

  /**
   * Active/désactive l'appareil
   */
  switchActivation(): void {
    //On crée une copie du device courant pour ne pas affecter le listItem tant que l'enregistrement n'est pas OK
    let device: MobileDevice = Object.assign({},this.data);

    //Activation/désactivation
    device.actif = !device.actif;

    //Appel au service
    this.profilService.saveMobileDevice(device)
        .pipe(first())
        .subscribe((result: Result) => {
          //Vérification du résultat
          if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
            //Est-ce une activation
            if (device.actif) {
              //Toast succès activation
              this.toastrService.success(this.translateService.instant('profilUser.mobile.succesActivation'));
            } else {
              //Toast succès désactivation
              this.toastrService.success(this.translateService.instant('profilUser.mobile.succesDesactivation'));
            }

            //Refresh liste
            this.liste.refresh();
          } else {
            //Gestion de l'erreur
            TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastrService);
          }
        });
  }

  /**
   * Suppression de l'appareil
   */
  delete(): void {
    //Message de confirmation
    this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
        .pipe(filter(isConfirmed => isConfirmed))
        .subscribe(() => {
          //Appel au service
          this.profilService.deleteMobileDevice(this.data.idDevice)
              .pipe(first())
              .subscribe((result: Result) => {
                //Vérification du résultat
                if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                  //Toast succès
                  this.toastrService.success(this.translateService.instant('global.success.suppression'));

                  //Refresh liste
                  this.liste.refresh();
                } else {
                  //Gestion de l'erreur
                  TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastrService);
                }
              });
        });
  }
}
